import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

/** Rest state */

export const getRestCheckboxStyle = () => css`
  border-color: ${({ theme }) => theme.color.semantic.primary.border.default};
`;

export const getRestIndeterminateCheckboxStyle = () => css`
  height: 2px;
  background-color: ${({ theme }) => theme.color.semantic.primary.type.inverted};
`;

export const getRestCheckedCheckboxStyle = () => css`
  border-color: ${({ theme }) => theme.color.semantic.primary.border.default};
  background-color: ${({ theme }) => theme.color.semantic.primary.background.default};
`;

/** Hover state */

export const getHoverCheckboxStyle = () => css`
  border-color: ${({ theme }) => theme.color.semantic.primary.border.default} !important;
  background-color: ${({ theme }) => theme.color.semantic.primary.background.hoverWeak};
`;

export const getHoverCheckedCheckboxStyle = () => css`
  background-color: ${({ theme }) => theme.color.semantic.primary.background.hover} !important;
  border-color: ${({ theme }) => theme.color.semantic.primary.background.hover} !important;
`;

/** Pressed state */

export const getPressedCheckboxStyle = () => css`
  background-color: ${({ theme }) => theme.color.semantic.primary.background.pressedWeak};
`;

export const getPressedCheckedCheckboxStyle = () => css`
  background-color: ${({ theme }) => theme.color.semantic.primary.background.pressed} !important;
  border-color: ${({ theme }) => theme.color.semantic.primary.background.pressed} !important;
`;

/** Disabled state */
export const getDisabledCheckboxStyle = () => css`
  border-color: ${({ theme }) => theme.color.semantic.primary.border.disabled} !important;
  background-color: ${({ theme }) => theme.color.semantic.primary.background.disabled} !important;
`;

export const getDisabledCheckedCheckboxStyle = () => css`
  border-color: ${({ theme }) => theme.color.semantic.primary.border.disabled} !important;
`;

export const getDisabledIndeterminateCheckboxStyle = () => css`
  background-color: ${({ theme }) => theme.color.semantic.primary.type.disabled} !important;
`;

export const getCheckboxStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  line-height: 1;
  transition: box-shadow 0.4s ease;

  /* Rest state */

  .ant-checkbox-inner {
    ${getRestCheckboxStyle()}
  }

  .ant-checkbox-indeterminate {
    .ant-checkbox-inner::after {
      ${getRestIndeterminateCheckboxStyle()}
    }
  }
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      ${getRestCheckedCheckboxStyle()}
    }
  }

  /* Hover state */

  &:hover {
    .ant-checkbox-inner {
      ${getHoverCheckboxStyle()}
    }

    .ant-checkbox-checked:not(.ant-checkbox-disabled) {
      .ant-checkbox-inner {
        ${getHoverCheckedCheckboxStyle()}
      }
    }
  }

  /* Pressed state */

  &:active {
    .ant-checkbox-inner {
      ${getPressedCheckboxStyle()}
    }

    .ant-checkbox-checked:not(.ant-checkbox-disabled) {
      .ant-checkbox-inner {
        ${getPressedCheckedCheckboxStyle()}
      }
    }
  }

  /* Disabled state */

  .ant-checkbox-disabled {
    .ant-checkbox-inner {
      ${getDisabledCheckboxStyle()}
    }
  }

  .ant-checkbox-disabled.ant-checkbox-indeterminate {
    .ant-checkbox-inner::after {
      ${getDisabledIndeterminateCheckboxStyle()}
    }
  }

  .ant-checkbox-disabled.ant-checkbox-checked {
    .ant-checkbox-inner::after {
      ${getDisabledCheckedCheckboxStyle()}
    }
  }
`;
